import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// ADMIN USER APIs
// ================================
// 1) ADMIN LOGIN
export async function adminLoginApi(payload) {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/auth/login`,
      {
        email: payload.email || "",
        password: payload.password || "",
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    return res.data;
  } catch (err) {
    return {
      status: false,
      type: "danger",
      success: err.response?.data?.message || err.response?.data?.success || "Admin login failed",
    };
  }
}